// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"976b04b1","453":"175433d1","515":"be5c4fa6"}[chunkId] + ".chunk.js";
};